import { useEffect, useState } from "react";
import '../Styles/Header.css'
import { Link } from "react-router-dom";



function Header() {
  const [showModal, setshowModal] = useState(false);
  const [theme, setTheme] = useState(
    localStorage.getItem("currentMode") ?? "dark" 
  );

  useEffect(() => {
    if (theme === "light") {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
    } else {
      document.body.classList.remove("light");
      document.body.classList.add("dark");
    }
  }, [theme]);


  return (
    <header className="header ">

      <nav>
        <div>
          <button
            onClick={() => {
              setshowModal(true);
            }}
            className="menu icon-menu flex"
          >
            {" "}
          </button>

        </div>
        {window.location.href === 'https://amineaabada-75c6a.web.app' ?
          <div className='links'>
            <ul>
              <li >
                <Link className='activv' to="/">Home</Link>
              </li>
              <li>
                <a href="#Skills">Skills</a>
              </li>
              <li>
                <Link to="/Main">Projects</Link>
              </li>
              <li>
                <a href="#Contact-Me">Contact Me</a>
              </li>
            </ul>
          </div> :
          <div className='links'>
            <ul>
              <li >
                <Link className='activv' to="/">Home</Link>
              </li>
              <li>
                <Link to="/">Skills</Link>
              </li>
              <li>
                <Link to="/Main">Projects</Link>
              </li>
              <li>
                <Link to="/">Contact Me</Link>
              </li>
            </ul>
          </div>}
        <button
          onClick={() => {
            // Send value to LS
            localStorage.setItem(
              "currentMode",
              theme === "dark" ? "light" : "dark"
            );

            // get value from LS
            setTheme(localStorage.getItem("currentMode"));
          }}
          className="mode flex"
        >
          {theme === "dark" ? (
            <span className="icon-moon-o"> </span>
          ) : (
            <span className="icon-sun"> </span>
          )}
        </button>
      </nav>

      {showModal && (
        <div className="fixed">
          {window.location.href === 'https://amineaabada-75c6a.web.app' ?
            <ul className="modal ">
              <li>
                <button
                  className="icon-close"
                  onClick={() => {
                    setshowModal(false);
                  }}
                />
              </li>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/">Skills</Link>
              </li>
              <li>
                <Link to="/Main">Projects</Link>
              </li>
              <li>
                <Link to="/">Contact Me</Link>
              </li>
            </ul>
            :
            <ul className="modal ">
              <li>
                <button
                  className="icon-close"
                  onClick={() => {
                    setshowModal(false);
                  }}
                />
              </li>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/">Skills</Link>
              </li>
              <li>
                <Link to="/Main">Projects</Link>
              </li>
              <li>
                <Link to="/">Contact Me</Link>
              </li>
            </ul>
          }

        </div>
      )}
    </header>
  )
}

export default Header
